import type { Ref } from 'vue'
import { ref } from 'vue'

import useAccount from '@/common/composable/useAccount'

import { useLocalStorage } from 'vue-composable'

interface SharedFiltersStorage {
    managerId: number | null
}

const STORAGE_TOKEN = 'bpms-shared-filters'
const account = useAccount()

class SharedFilters {
    private _managerId: Ref<number | null> = ref(null)

    constructor() {
        const { storage } = useLocalStorage(STORAGE_TOKEN)

        let shared_filters_storage = undefined as SharedFiltersStorage | undefined

        if (typeof storage.value === 'object') {
            shared_filters_storage = storage.value
        }

        if (typeof storage.value === 'string' && storage.value !== 'undefined') {
            shared_filters_storage = JSON.parse(storage.value)
        }

        if (shared_filters_storage) {
            this.managerId = shared_filters_storage.managerId
        }

        if (this.managerId === null) {
            this.managerId = account.state.user_id
        }
    }

    get managerId(): number | null {
        return this._managerId.value
    }

    set managerId(value: number | null) {
        this._managerId.value = value
        this.updateStorage()
    }

    public updateStorage(): void {
        const { storage } = useLocalStorage(STORAGE_TOKEN)

        storage.value = JSON.stringify({
            managerId: this.managerId,
        })
    }

    public resetStorage(): void {
        this._managerId.value = null
        this.updateStorage()
    }
}

const sharedFilters = new SharedFilters()
export default sharedFilters